import { spacing } from "globalStyles";
import React from "react";
import styled from "styled-components";
import Body from "ui/Text/Body";
import { InputColor } from "../interfaces";

interface Props {
  color: InputColor;
  hasError: boolean;
  errorMessage?: string;
  helperText?: string;
}

const InputHelperText: React.FC<Props> = ({
  hasError,
  errorMessage,
  helperText,
  color,
}) => {
  return (
    <HelperText hasError={hasError} variant="body7" inputColor={color}>
      {hasError && errorMessage ? errorMessage : helperText}
    </HelperText>
  );
};

export default InputHelperText;

const HelperText = styled(Body)<{ inputColor: InputColor; hasError: boolean }>`
  margin-top: ${spacing.extraSmall}px;
  color: ${({ theme, inputColor, hasError }) =>
    hasError ? theme.colors.text.danger : theme.colors.input[inputColor].content};
`;
